export default {
  title: 'Buscador'
}